import { ScrollArea, cn } from '@repo/shadcn';
import { Box, Home } from 'lucide-react';
import { useState } from 'react';
import {
    Menu,
    MenuItem,
    Sidebar,
    SubMenu,
    menuClasses,
    sidebarClasses,
} from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';

import { EnvConfig } from '@configs/env.config';

import { SIDEBAR_MENU } from '@/configs';
import { Route } from '@/constants';
import { generatePermissionType } from '@/utils';

import { usePermission } from '../../hooks';
import { AuthorizationSidebarWrapper } from '../auth';
import { SidebarHeader } from '../templates/sidebar/sidebar-header';

type AdminSidebarProps = {
    isCollapsed?: boolean;
    setIsCollapsed?: (collapsed: boolean) => void;
};

export const AdminSidebar = ({
    isCollapsed = false,
    setIsCollapsed,
}: AdminSidebarProps) => {
    const location = useLocation();
    const [activeMenuItem, setActiveMenuItem] = useState<string | null>(null);
    const { isAdmin } = usePermission([]);

    const version = EnvConfig.VERSION;

    return (
        <Sidebar
            collapsed={isCollapsed}
            width="250px"
            collapsedWidth={'65px'}
            rootStyles={{
                [`.${sidebarClasses.container}`]: {
                    fontSize: '16px',
                },
                background: 'white',
                height: '100vh',
                position: 'sticky',
                top: '0',
            }}
        >
            <SidebarHeader />
            <ScrollArea className="h-[calc(100vh_-_var(--header-height)_-_50px)]">
                <hr />

                <Menu
                    rootStyles={{
                        [`.${menuClasses.label}`]: {
                            fontSize: '13px',
                            fontWeight: 500,
                            color: '#303030',
                        },
                    }}
                    style={{
                        zIndex: 999,
                    }}
                >
                    <Link to={Route.DASHBOARD}>
                        <MenuItem
                            icon={<Home />}
                            active={location.pathname === Route.DASHBOARD}
                            rootStyles={{
                                backgroundColor:
                                    location.pathname === Route.DASHBOARD
                                        ? 'rgba(135,206,255, 0.30)'
                                        : 'transparent',
                            }}
                        >
                            Dashboard
                        </MenuItem>
                    </Link>

                    {SIDEBAR_MENU.slice(0, 6).map((menuItem) => (
                        <AuthorizationSidebarWrapper
                            key={menuItem.label}
                            requiredPermission={menuItem?.children?.reduce(
                                (acc, child) => {
                                    child.permissions.forEach((perm) => {
                                        acc.push(
                                            generatePermissionType(
                                                perm.resource,
                                                perm.action,
                                            ),
                                        );
                                    });
                                    return acc;
                                },
                                [] as string[],
                            )}
                        >
                            <SubMenu
                                key={menuItem.label}
                                label={menuItem.label}
                                icon={menuItem.icon}
                                open={activeMenuItem === menuItem.label}
                                onClick={() => {
                                    setActiveMenuItem(
                                        activeMenuItem === menuItem.label
                                            ? null
                                            : menuItem.label,
                                    );
                                    setIsCollapsed?.(false);
                                }}
                                active={location.pathname.startsWith(
                                    '/' +
                                        menuItem.children[0]?.path?.split(
                                            '/',
                                        )[1],
                                )}
                                rootStyles={{
                                    // // backgroundColor: 'red',
                                    // paddingLeft: '12px !important',
                                    backgroundColor:
                                        location.pathname.startsWith(
                                            '/' +
                                                menuItem.children[0]?.path?.split(
                                                    '/',
                                                )[1],
                                        )
                                            ? 'rgba(135,206,255, 0.15)'
                                            : 'transparent',
                                    // [`.${menuClasses.button}`]: {
                                    //   marginLeft: '0px',
                                    // },
                                }}
                            >
                                {menuItem.children.map((child) => (
                                    <AuthorizationSidebarWrapper
                                        key={child.label}
                                        requiredPermission={child.permissions.map(
                                            (perm) =>
                                                generatePermissionType(
                                                    perm.resource,
                                                    perm.action,
                                                ),
                                        )}
                                    >
                                        <Link to={child.path}>
                                            <MenuItem
                                                rootStyles={{
                                                    [`.${menuClasses.button}`]:
                                                        {
                                                            marginLeft: '32px',
                                                        },
                                                }}
                                                style={{
                                                    backgroundColor:
                                                        location.pathname ===
                                                        child.path
                                                            ? 'rgba(135,206,255, 0.30)'
                                                            : 'transparent',
                                                }}
                                                // icon={child.icon}
                                            >
                                                {child.label}
                                            </MenuItem>
                                        </Link>
                                    </AuthorizationSidebarWrapper>
                                ))}
                            </SubMenu>
                        </AuthorizationSidebarWrapper>
                    ))}

                    {isAdmin && (
                        <Link to={Route.CASH_BOX}>
                            <MenuItem
                                icon={<Box />}
                                active={location.pathname === Route.CASH_BOX}
                                rootStyles={{
                                    backgroundColor:
                                        location.pathname === Route.CASH_BOX
                                            ? 'rgba(135,206,255, 0.30)'
                                            : 'transparent',
                                }}
                            >
                                Cash Box
                            </MenuItem>
                        </Link>
                    )}

                    {SIDEBAR_MENU.slice(6).map((menuItem) => (
                        <AuthorizationSidebarWrapper
                            key={menuItem.label}
                            requiredPermission={menuItem?.children?.reduce(
                                (acc, child) => {
                                    child.permissions.forEach((perm) => {
                                        acc.push(
                                            generatePermissionType(
                                                perm.resource,
                                                perm.action,
                                            ),
                                        );
                                    });
                                    return acc;
                                },
                                [] as string[],
                            )}
                        >
                            <SubMenu
                                key={menuItem.label}
                                label={menuItem.label}
                                icon={menuItem.icon}
                                open={activeMenuItem === menuItem.label}
                                onClick={() => {
                                    setActiveMenuItem(
                                        activeMenuItem === menuItem.label
                                            ? null
                                            : menuItem.label,
                                    );
                                    setIsCollapsed?.(false);
                                }}
                                active={location.pathname.startsWith(
                                    '/' +
                                        menuItem.children[0]?.path?.split(
                                            '/',
                                        )[1],
                                )}
                                rootStyles={{
                                    // // backgroundColor: 'red',
                                    // paddingLeft: '12px !important',
                                    backgroundColor:
                                        location.pathname.startsWith(
                                            '/' +
                                                menuItem.children[0]?.path?.split(
                                                    '/',
                                                )[1],
                                        )
                                            ? 'rgba(135,206,255, 0.15)'
                                            : 'transparent',
                                    // [`.${menuClasses.button}`]: {
                                    //   marginLeft: '0px',
                                    // },
                                }}
                            >
                                {menuItem.children.map((child) => (
                                    <AuthorizationSidebarWrapper
                                        key={child.label}
                                        requiredPermission={child.permissions.map(
                                            (perm) =>
                                                generatePermissionType(
                                                    perm.resource,
                                                    perm.action,
                                                ),
                                        )}
                                    >
                                        <Link to={child.path}>
                                            <MenuItem
                                                rootStyles={{
                                                    [`.${menuClasses.button}`]:
                                                        {
                                                            marginLeft: '32px',
                                                        },
                                                }}
                                                style={{
                                                    backgroundColor:
                                                        location.pathname ===
                                                        child.path
                                                            ? 'rgba(135,206,255, 0.30)'
                                                            : 'transparent',
                                                }}
                                                // icon={child.icon}
                                            >
                                                {child.label}
                                            </MenuItem>
                                        </Link>
                                    </AuthorizationSidebarWrapper>
                                ))}
                            </SubMenu>
                        </AuthorizationSidebarWrapper>
                    ))}
                </Menu>
            </ScrollArea>

            <div
                className={cn(
                    'h-[50px] flex-col items-start justify-center border-t-2 p-4 shadow-md',
                    isCollapsed ? 'hidden' : 'flex',
                )}
            >
                <p className={'text-sm'}>
                    Version:{' '}
                    <span className={'font-mono font-bold'}>{version}</span>
                </p>
                <p className={'text-sm'}>
                    Developed By:{' '}
                    <a
                        className={'font-primary font-bold text-primary'}
                        target={'_blank'}
                        href={'https://intwins.com'}
                    >
                        IntWins
                    </a>
                </p>
            </div>

            <div
                className={cn(
                    'h-[50px] flex-col items-center justify-center border-t-2 shadow-md',
                    isCollapsed ? 'flex' : 'hidden',
                )}
            >
                <p className={'text-xs'}>
                    V:
                    <span className={'font-bold'}>{version}</span>
                </p>
            </div>
        </Sidebar>
    );
};
